import { useCallback, useState } from "react"

const useActive = () => {
  const [isActive, setIsActive] = useState(false)

  const onPointerDown = useCallback((e: React.PointerEvent) => {
    // マウス入力の場合、第1ボタン（通常は左クリック）以外の入力は無視します。
    // https://developer.mozilla.org/ja/docs/Web/API/MouseEvent/button
    if (e.pointerType === "mouse" && e.button !== 0) {
      return
    }

    setIsActive(true)

    // onPointerUpなどをイベントハンドラとして設定しても、要素外ではイベントが発生しないため、windowにイベントリスナーを設定します。
    const remove = () => {
      setIsActive(false)
      window.removeEventListener("pointerup", remove)
      window.removeEventListener("pointercancel", remove)
    }

    window.addEventListener("pointerup", remove, { once: true })
    window.addEventListener("pointercancel", remove, { once: true })
  }, [])

  return {
    isActive,
    activeProps: {
      onPointerDown,
    },
  }
}

export default useActive
